import { API_ENDPOINTS } from "../config/apiEndpoints";
import { lookup } from "../types/lookupFilters";
import { requests } from "./apiClient";

export const fetchClients = (signal: AbortSignal): Promise<lookup[]> =>
  requests.get<lookup[]>(API_ENDPOINTS.LOOKUP.CLIENTS, signal);

export const fetchStatuses = (signal: AbortSignal): Promise<lookup[]> =>
  requests.get<lookup[]>(API_ENDPOINTS.LOOKUP.FILE_STATUS, signal);

export const fetchTaxYears = (signal: AbortSignal): Promise<lookup[]> =>
  requests.get<lookup[]>(API_ENDPOINTS.LOOKUP.TAX_YEARS, signal);

export const fetchPrintYears = (signal: AbortSignal): Promise<lookup[]> =>
  requests.get<lookup[]>(API_ENDPOINTS.LOOKUP.PRINT_YEARS, signal);

export const fetchDataValidationLevels = (
  signal: AbortSignal
): Promise<lookup[]> =>
  requests.get<lookup[]>(
    API_ENDPOINTS.LOOKUP.DATA_VALIDALIDATION_LEVELS,
    signal
  );

export const fetchRoles = (signal: AbortSignal): Promise<lookup[]> =>
  requests.get<lookup[]>(API_ENDPOINTS.LOOKUP.ROLES, signal);

export const fetchStatesLookup = (
  signal: AbortSignal,
  includeFederal: boolean = false
): Promise<string[]> => {
  return requests.get<string[]>(
    `${API_ENDPOINTS.LOOKUP.STATES}?includeFederal=${includeFederal}`,
    signal
  );
};

export const fetchFileTypes = (signal: AbortSignal): Promise<lookup[]> =>
  requests.get<lookup[]>(API_ENDPOINTS.LOOKUP.FileTypes, signal);

export const fetchFeinsByClientId = (
  signal: AbortSignal,
  clientId?: string
): Promise<string[]> =>
  requests.get<string[]>(
    API_ENDPOINTS.LOOKUP.getFeinsByClientId(clientId),
    signal
  );

export const fetchImportFileTypes = (signal: AbortSignal): Promise<lookup[]> =>
  requests.get<lookup[]>(API_ENDPOINTS.LOOKUP.ImportFileTypes, signal);

export const fetchValidationErrorTypes = (
  signal: AbortSignal
): Promise<lookup[]> =>
  requests.get<lookup[]>(API_ENDPOINTS.LOOKUP.ValidationErrorTypes, signal);
